import React from "react";
import ReactDOM from "react-dom/client";

// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";
// Bootstrap Icons
import "bootstrap-icons/font/bootstrap-icons.css";
// React DatePicker CSS
import "react-datepicker/dist/react-datepicker.css";
// React-Grid-Layout Styles
import "react-grid-layout/css/styles.css";
// React-Resizable Styles
import "react-resizable/css/styles.css";
// Custom Styles
import "./styles/index.scss";
import "./styles/generic-darktheme.scss";
import "./styles/charts-dark.scss"; // dark-mode chart colours (one file)

import App from "./app/App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
